<app-header></app-header>

<div class="container main-page">
  <div class="col-md-6 mt-6 mx-auto">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="vertical-align: middle;font-size:16px;font-weight:800">Product ID</td>
          <td colspan="2">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="selectedproductId"
              placeholder=""
            />
          </td>
        </tr>

        <tr>
          <td style="vertical-align: middle;font-size:16px;font-weight:800">Published Date</td>
          <td>
            <app-drop-down-single-select
              [DropDownOptions]="selectTypeDropDownOptions"
              (typeSelectedChanged)="updateSelectedType($event)"
              [name]="'publishedDate'"
              [selectedOption]="publishedDateSelectedFilterData['selectedFilterType']"
              (resetAllVal)="resetDropDownVal($event)"
            ></app-drop-down-single-select>
          </td>
          <td>
            <app-date-select
              [additionalClasses]="'float-left'"
              [product]=""
              type="publishedDate"
              (dateSelected)="updateSelectedDate($event)"
              [inputDate]="publishedDateSelectedFilterData['currentVal']"
              (resetDateVal)="resetDateVal($event)"
            ></app-date-select>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle;font-size:16px;font-weight:800">Contracted Date</td>
          <td>
            <app-drop-down-single-select
              [DropDownOptions]="selectTypeDropDownOptions"
              (typeSelectedChanged)="updateSelectedType($event)"
              [name]="'contractedDate'"
              (resetAllVal)="resetDropDownVal($event)"
            ></app-drop-down-single-select>
          </td>
          <td>
            <app-date-select
              [additionalClasses]="'float-left'"
              [product]=""
              type="contractedDate"
              (dateSelected)="updateSelectedDate($event)"
              (resetDateVal)="resetDateVal($event)"
            ></app-date-select>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle;font-size:16px;font-weight:800">Status</td>
          <td>
            <app-drop-down-single-select
              [DropDownOptions]="selectStatusTypeDropDownOptions"
              (typeSelectedChanged)="updateSelectedType($event)"
              [name]="'status'"
              (resetAllVal)="resetDropDownVal($event)"
            ></app-drop-down-single-select>
          </td>
          <td>
            <app-drop-down
              type="bookStatus"
              [settings]="dropdownSettingsBookType"
              [list]="dropdownListBookStatus"
              (dropDownChanged)="updateSelectedDropDown($event)"
            ></app-drop-down>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle;font-size:16px;font-weight:800">Product Type</td>
          <td colspan="2">
            <app-drop-down
              type="productType"
              [settings]="dropdownSettingsProductType"
              [list]="dropdownListProductType"
              (dropDownChanged)="updateSelectedDropDown($event)"
            ></app-drop-down>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle;font-size:16px;font-weight:800">Book Type</td>
          <td colspan="2">
            <app-drop-down
              type="bookType"
              [settings]="dropdownSettingsBookType"
              [list]="dropdownListBookType"
              (dropDownChanged)="updateSelectedDropDown($event)"
            ></app-drop-down>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- <div class="col-md-12 mt-6">
    <div>
      <div class="row float-right">
        <div class="col-md-4 mt-8 offset-md-10 search-dwnload-btn-bar">
          <button
            type="submit"
            class="btn search-btn btn-primary ol-btn"
            (click)="search()"
          >
            Search
            <i class="bi bi-search ps-1"></i>
          </button>
          <button
            type="submit"
            class="btn search-btn btn-success ms-1"
            (click)="downloadReport()"
          >
            Download
            <i class="bi bi-download ps-1"></i>
          </button>

          <button
            class="btn search-btn btn-success ms-1"
            (click)="clearFilters()"
          >
            Reset
            <i class="bi bi-trash-fill"></i>
          </button>
        </div>
      </div>
    </div>
  </div> -->

  <div class="container table-responsive" style="overflow-x: auto;">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button
      type="submit"
      class="btn search-btn btn-primary ol-btn"
      (click)="search()"
    >
      Search
      <i class="bi bi-search ps-1"></i>
    </button>
    <button
      type="submit"
      class="btn search-btn btn-success ms-1"
      (click)="downloadReport()"
    >
      Download
      <i class="bi bi-download ps-1"></i>
    </button>

    <button
      class="btn search-btn btn-success ms-1"
      (click)="clearFilters()"
    >
      Reset
      <i class="bi bi-trash-fill"></i>
    </button>
    </div>
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col" class="width-10">Product ID</th>
          <th scope="col" class="width-15">Title</th>
          <th scope="col" class="width-10">Format</th>
          <th scope="col" class="width-20">BookType</th>

          <th scope="col" class="width-20">EPD</th>
          <th scope="col" class="width-15">ISBN-10E</th>
          <th scope="col" class="width-15">ISBN-13E</th>
          <th scope="col" class="width-15">ISBN-13P</th>
          <th scope="col" class="width-15">ISBN-10P</th>
          <th scope="col" class="width-15">Publishing Department</th>

          <th scope="col" class="width-15">Brand Id</th>

          <th scope="col" class="width-15">Publisher Name</th>
          <th scope="col" class="width-15">Acquisition Editor</th>
          <th scope="col" class="width-15">Contracting AE</th>
          <th scope="col" class="width-15">Topic</th>
          <th scope="col" class="width-15">Published Date</th>
          <th scope="col" class="width-15">Page count</th>
          <th scope="col" class="width-15">ISBN-13P</th>
          <th scope="col" class="width-15">Brand</th>
          <th scope="col" class="width-15">Status</th>
          <th scope="col" class="width-15">Contracted Date</th>
          <th scope="col" class="width-15">Terminated Date</th>
          <th scope="col" class="width-15">Cancelled Date</th>
          <th scope="col" class="width-15">Commercial Priority</th>
          <!-- <th scope="col" class="width-15">enter name</th> -->
          <!-- <th scope="col" class="width-15">Email address</th> -->
          <th scope="col" class="width-15">E-Book Price (USD)</th>
          <th scope="col" class="width-15">E-Book Price</th>
          <th scope="col" class="width-15">Print Price (USD)</th>
          <th scope="col" class="width-15">Commercial Priority</th>
          <th scope="col" class="width-15">CM Category</th>
          <th scope="col" class="width-15">IEPD</th>
          <th scope="col" class="width-15">DDPD</th>
          <th scope="col" class="width-15">Final Page Count</th>
          <!-- <th scope="col" class="width-15">CM Category</th> -->
          <th scope="col" class="width-15">Final Printers Uploaded Date</th>
          <th scope="col" class="width-15">Commit Date</th>
          <th scope="col" class="width-15">Revised Commit Date</th>
          <th scope="col" class="width-15">Second Revised Commit Date</th>
          <!-- <th scope="col" class="width-15">Terminated Date</th> -->
          <!-- <th scope="col" class="width-15">derivative products</th> -->
          <th scope="col" class="width-15">Is a Derivative Product</th>
          <!-- <th scope="col" class="width-15">Assigned To</th>
          <th scope="col" class="width-15">Publishing Department</th> -->
          <!-- <th scope="col" class="width-15">enter name</th>
          <th scope="col" class="width-15">enter name</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products">
          <td>
            {{product.part_number }}
          </td>
          <td>
            {{product.name }}
          </td>
          <td>
            {{product?.type[0]?.name }}
          </td>
          <td>
            {{product.book_type }}
          </td>
          <td>
            {{product?.date?.epd }}
          </td>
          <td>
            {{product?.isbn?.isbn_10e}}
          </td>
          <td>
            {{product?.isbn?.isbn_13e}}
          </td>
          <td>
            {{product?.isbn?.isbn_13}}
          </td>
          <td>
            {{product?.isbn?.isbn_10}}
          </td>
          <td>
            {{product?.team?.name}}
          </td>
          <td>
            {{product?.brand}}
          </td>
          <td>
            {{product?.publisher[0]?.user?.first_name}}
            {{product?.publisher[0]?.user?.last_name}}
          </td>
          <td>
            {{product?.acquisition_editor[0]?.user?.first_name}}
            {{product?.acquisition_editor[0]?.user?.last_name}}
          </td>
          <td>
            {{product?.contracting_a_eo_r_p_p_m[0]?.user?.first_name}}
            {{product?.contracting_a_eo_r_p_p_m[0]?.user?.last_name}}
          </td>
          <td>
            {{product?.book_topic}}
          </td>
          <td>
            {{product?.date?.ppd}}
          </td>
          <td>
            {{product?.length_book}}
          </td>
          <td>
            {{product?.isbn?.isbn_13}}
          </td>
          <td>
            {{product?.brand}}
          </td>
          <td>
            {{product?.status[0]?.name}}
          </td>
          <td>
            {{product?.date?.contracted_date}}
          </td>
          <!-- <td>
            TERMINATED DATE
          </td> -->
          <td>
            {{product?.date?.cancelled_date}}
          </td>
          <td>
            {{product?.commercial_priority}}
          </td>
          <!-- <td>
            ENTER NAME
          </td> -->
          <td></td>
          <ng-container *ngFor="let price of product.price">
            <td
              *ngIf="(price.currency == 'USD' && price.product_type == 'eBook')"
            >
              {{price?.price}}
            </td>
            <td
              *ngIf="(price.currency == 'GBP' && price.product_type == 'eBook')"
            >
              {{price?.price}}
            </td>
            <td
              *ngIf="(price.currency == 'USD' && price.product_type == 'Book')"
            >
              {{price?.price}}
            </td>
          </ng-container>

          <ng-container
            *ngIf="product.price.length == 0 || product?.type[0]?.name == 'Video' || product?.type[0]?.name == 'AudioBook'"
          >
            <td></td>
            <td></td>
            <td></td>
          </ng-container>
          <td>
            {{product?.commercial_priority}}
          </td>
          <td>
            {{(product?.pkt_job_role && product.pkt_job_role.length > 0 &&
            product.pkt_job_role[0].job_role_primary.length > 0 ) ?
            product.pkt_job_role[0].job_role_primary[0].name : '' }}
          </td>
          <td>
            {{product?.date?.iepd}}
          </td>
          <td>
            {{product?.product_cstm?.drop_dead_dte_c}}
          </td>
          <td>
            {{product?.final_length_book}}
          </td>
          <!-- <td>
            {{(product?.pkt_job_role && product.pkt_job_role.length > 0 &&
            product.pkt_job_role[0].job_role_primary.length > 0 ) ?
            product.pkt_job_role[0].job_role_primary[0].name : '' }}
          </td> -->
          <td>
            {{product?.date?.fpup}}
          </td>
          <td>
            {{product?.date?.commit_date}}
          </td>
          <td>
            {{product?.date?.revised_commit_date}}
          </td>
          <td>
            {{product?.date?.second_revised_commit_date}}
          </td>
          <!-- <td>
            TERMINATED
          </td> -->
          <!-- <td>
            DERIVATIVE PRODUCTS
          </td> -->
          <td *ngIf="product.is_derivative == 1 ;else derivative_false">
            true
          </td>

          <ng-template #derivative_false
            ><td>
              false
            </td></ng-template
          >

          <!-- <td>
            {{product?.assigned_user?.first_name}}{{product?.assigned_user?.last_name}}
          </td> -->
          <!-- <td>
            {{product?.team?.name}}
          </td> -->
          <!-- <td>
            ENTER NAME
          </td>
          <td>
            ENTER NAME
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>